import React from 'react';
import { popoverOptions } from '@popmenu/admin-ui';
import { useRestaurantFeatures } from '~/admin/hooks';
import { ThemeProvider } from '../utils/withStyles';

export const UserThemeProvider = ({ children }: { children: React.ReactNode }) => {
  const { isFeatureActive } = useRestaurantFeatures();
  const isPopoverDesignEnabled = isFeatureActive('popover_design');

  return (
    <ThemeProvider mypopTheme={isPopoverDesignEnabled ? popoverOptions : undefined}>
      {children}
    </ThemeProvider>
  );
};
